/* ==========================================================================
   Eisnova Red Light Therapy Mat — shared interactions
   Works with Shopify product forms + Theme Editor section reloads.
   Document-level delegated listeners are attached once; per-section state
   (sticky observer, price sync) is (re)initialised on load + shopify:section:load.
   ========================================================================== */
(function () {
  if (window.__rlBound) { rlInitAll(); return; }
  window.__rlBound = true;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- variant selection + price sync ---------- */
  function applyVariant(scope, input) {
    if (!input) return;
    var price = input.getAttribute('data-price') || '';
    var compare = input.getAttribute('data-compare') || '';
    var save = input.getAttribute('data-save') || '';
    var available = input.getAttribute('data-available') !== 'false';

    // highlight selected card
    $all('.rl-variant', scope).forEach(function (el) {
      el.classList.toggle('rl-sel', el.contains(input));
    });

    // hero price block
    var now = $('[data-rl-price-now]', scope); if (now) now.textContent = price;
    var was = $('[data-rl-price-was]', scope); if (was) { was.textContent = compare; was.style.display = compare ? '' : 'none'; }
    var badge = $('[data-rl-save]', scope);
    if (badge) { badge.textContent = badge.getAttribute('data-tpl') ? badge.getAttribute('data-tpl').replace('{save}', save) : save; badge.style.display = save ? '' : 'none'; }

    // sticky bar (lives outside the hero section — sync globally by variant id)
    var id = input.value;
    $all('[data-rl-sticky]').forEach(function (bar) {
      var sp = $('[data-rl-sticky-price]', bar); if (sp) sp.textContent = price;
      var sw = $('[data-rl-sticky-was]', bar); if (sw) sw.textContent = compare;
    });

    // CTA availability
    $all('[data-rl-atc]', scope).forEach(function (btn) {
      var labelEl = btn.querySelector('span') || btn;
      if (!available) {
        btn.setAttribute('disabled', 'disabled');
        labelEl.textContent = btn.getAttribute('data-soldout') || 'Sold out';
      } else {
        btn.removeAttribute('disabled');
        if (btn.getAttribute('data-label')) labelEl.textContent = btn.getAttribute('data-label').replace('{save}', save);
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('.rl-variant input[type="radio"]')) {
      var scope = e.target.closest('.rl-scope') || document;
      applyVariant(scope, e.target);
    }
  });
  document.addEventListener('click', function (e) {
    // info badge: open/close the variant explanation, never select the variant
    var info = e.target.closest('[data-rl-vinfo]');
    if (info) {
      e.preventDefault();
      var card = info.closest('.rl-variant');
      var pop = card && card.querySelector('[data-rl-vinfo-pop]');
      var isOpen = pop && pop.classList.contains('rl-open');
      $all('[data-rl-vinfo-pop].rl-open').forEach(function (p) { p.classList.remove('rl-open'); });
      if (pop && !isOpen) pop.classList.add('rl-open');
      return;
    }
    // clicking an open popover (or outside) closes it
    if (!e.target.closest('[data-rl-vinfo-pop]')) {
      $all('[data-rl-vinfo-pop].rl-open').forEach(function (p) { p.classList.remove('rl-open'); });
    }
    var lab = e.target.closest('.rl-variant');
    if (lab) {
      var input = lab.querySelector('input[type="radio"]');
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });

  /* ---------- gallery ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.rl-thumb');
    if (!t) return;
    var gallery = t.closest('.rl-gallery'); if (!gallery) return;
    $all('.rl-thumb', gallery).forEach(function (x) { x.classList.remove('rl-active'); });
    t.classList.add('rl-active');
    var mainImg = $('[data-rl-main-img]', gallery);
    var src = t.getAttribute('data-full') || (t.querySelector('img') && t.querySelector('img').src);
    if (mainImg && src) { mainImg.src = src; mainImg.srcset = ''; if (t.getAttribute('data-alt')) mainImg.alt = t.getAttribute('data-alt'); }
  });

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rl-qty]');
    if (!btn) return;
    var wrap = btn.closest('.rl-qty-ctrl'); if (!wrap) return;
    var field = wrap.querySelector('input');
    var val = parseInt(field.value, 10) || 1;
    val += (btn.getAttribute('data-rl-qty') === 'up' ? 1 : -1);
    if (val < 1) val = 1;
    field.value = val;
  });

  /* ---------- add to cart (AJAX with graceful fallback) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.rl-product-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-rl-atc]');
    if (btn && btn.hasAttribute('disabled')) return;
    var labelEl = (btn && btn.querySelector('span')) || btn;
    var prev = labelEl ? labelEl.textContent : '';
    var data = new FormData(form);

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) { btn.classList.add('rl-added'); if (labelEl) labelEl.textContent = btn.getAttribute('data-added') || 'Added \u2713'; }
        // sync sticky button if present
        $all('[data-rl-sticky-cta]').forEach(function (s) { s.classList.add('rl-added'); s.textContent = s.getAttribute('data-added') || 'Added \u2713'; });
        // try to open the theme cart drawer / refresh count
        document.dispatchEvent(new CustomEvent('rl:added'));
        bumpCartCount(data.get('quantity'));
        setTimeout(function () {
          if (btn) { btn.classList.remove('rl-added'); if (labelEl) labelEl.textContent = prev; }
          $all('[data-rl-sticky-cta]').forEach(function (s) { s.classList.remove('rl-added'); s.textContent = s.getAttribute('data-label-plain') || prev; });
        }, 1900);
      })
      .catch(function () { form.submit(); }); // hard fallback -> /cart
  });

  // sticky CTA scrolls to the hero form and submits it
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-rl-sticky-cta]');
    if (!s) return;
    var form = $('form.rl-product-form');
    if (form) { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
  });

  function bumpCartCount(qty) {
    qty = parseInt(qty, 10) || 1;
    $all('[data-cart-count], .cart-count-bubble span, #cart-icon-bubble .cart-count-bubble').forEach(function (el) {
      var n = parseInt(el.textContent, 10); if (!isNaN(n)) el.textContent = n + qty;
    });
  }

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.rl-faq-q');
    if (!q) return;
    var item = q.closest('.rl-faq-item');
    var ans = item.querySelector('.rl-faq-a');
    var open = item.classList.contains('rl-open');
    var list = item.closest('.rl-faq-list');
    if (list) $all('.rl-faq-item.rl-open', list).forEach(function (it) {
      if (it !== item) { it.classList.remove('rl-open'); var a = it.querySelector('.rl-faq-a'); if (a) a.style.maxHeight = null; }
    });
    if (open) { item.classList.remove('rl-open'); ans.style.maxHeight = null; }
    else { item.classList.add('rl-open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
  });

  /* ---------- video modal ---------- */
  function rlCloseVid(modal) {
    if (!modal) return;
    modal.classList.remove('rl-open');
    document.body.style.overflow = '';
    var frame = modal.querySelector('[data-rl-vid-frame]');
    if (frame) frame.innerHTML = ''; // remove iframe -> stops playback & frees memory
  }
  function rlOpenVid(th, modal) {
    var titleEl = modal.querySelector('[data-rl-vid-title]');
    if (titleEl) titleEl.textContent = th.getAttribute('data-cap') || 'Video';
    var frame = modal.querySelector('[data-rl-vid-frame]');
    var ytid = th.getAttribute('data-yt');
    if (frame) {
      frame.innerHTML = '';
      if (ytid) { // build the iframe ONLY now (on click) -> zero page-load cost
        var ifr = document.createElement('iframe');
        ifr.src = 'https://www.youtube.com/embed/' + encodeURIComponent(ytid) + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
        ifr.title = th.getAttribute('data-cap') || 'Video';
        ifr.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        ifr.setAttribute('allowfullscreen', '');
        frame.appendChild(ifr);
      }
    }
    modal.classList.add('rl-open');
    document.body.style.overflow = 'hidden';
  }
  document.addEventListener('click', function (e) {
    var th = e.target.closest('.rl-vid-thumb');
    var modal = $('[data-rl-vid-modal]');
    if (th && modal) { rlOpenVid(th, modal); return; }
    if (modal && (e.target.closest('[data-rl-vclose]') || e.target === modal)) {
      rlCloseVid(modal);
    }
  });
  document.addEventListener('keydown', function (e) {
    var th = e.target.closest && e.target.closest('.rl-vid-thumb');
    if (th && (e.key === 'Enter' || e.key === ' ')) {
      var m = $('[data-rl-vid-modal]'); if (m) { e.preventDefault(); rlOpenVid(th, m); }
      return;
    }
    if (e.key === 'Escape') { rlCloseVid($('[data-rl-vid-modal]')); }
  });

  /* ---------- sticky bar reveal ---------- */
  var rlObserver = null;
  function initSticky() {
    var anchor = $('[data-rl-cta-anchor]');
    var bar = $('[data-rl-sticky]');
    if (!anchor || !bar || !('IntersectionObserver' in window)) return;
    if (rlObserver) rlObserver.disconnect();
    // hide bar while in Theme Editor preview of the sticky section itself
    rlObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.boundingClientRect.top < 0 && !en.isIntersecting) bar.classList.add('rl-show');
        else if (en.isIntersecting) bar.classList.remove('rl-show');
      });
    }, { threshold: 0 });
    rlObserver.observe(anchor);
  }

  /* ---------- mechanism loop video (lazy, muted, seamless loop, no YT chrome) ----------
     Uses the YouTube IFrame Player API so we can loop by seeking back to 0 on ENDED.
     That avoids the playlist= trick, which would add prev/next buttons. Combined with
     controls=0 + CSS that crops the title bar/logo, it reads as a clean background clip. */
  var rlMechObs = null;
  var rlYTReady = false;
  var rlYTQueue = [];
  function rlLoadYTAPI() {
    if (window.YT && window.YT.Player) { rlYTReady = true; return; }
    if (!document.getElementById('rl-yt-api')) {
      var s = document.createElement('script');
      s.id = 'rl-yt-api';
      s.src = 'https://www.youtube.com/iframe_api';
      (document.head || document.body).appendChild(s);
    }
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') { try { prev(); } catch (e) {} }
      rlYTReady = true;
      var q = rlYTQueue; rlYTQueue = [];
      q.forEach(function (fn) { try { fn(); } catch (e) {} });
    };
  }
  function rlMakePlayer(box, ytid) {
    var mount = document.createElement('div');
    box.appendChild(mount);
    var alt = (box.parentNode && box.parentNode.querySelector('img') && box.parentNode.querySelector('img').alt) || 'Video';
    /* eslint-disable no-new */
    new window.YT.Player(mount, {
      videoId: ytid,
      playerVars: { autoplay: 1, mute: 1, controls: 0, playsinline: 1, rel: 0, modestbranding: 1, disablekb: 1, fs: 0, iv_load_policy: 3, loop: 0 },
      events: {
        onReady: function (e) { try { e.target.setVolume(0); e.target.mute(); e.target.playVideo(); } catch (err) {} },
        onStateChange: function (e) { if (e.data === window.YT.PlayerState.ENDED) { try { e.target.seekTo(0, true); e.target.playVideo(); } catch (err) {} } }
      }
    });
  }
  function loadMechVid(box) {
    if (!box || box.getAttribute('data-rl-loaded')) return;
    var ytid = box.getAttribute('data-yt-loop');
    if (!ytid) return;
    box.setAttribute('data-rl-loaded', '1');
    rlLoadYTAPI();
    var run = function () { rlMakePlayer(box, ytid); };
    if (rlYTReady && window.YT && window.YT.Player) run();
    else rlYTQueue.push(run);
  }
  function initMechVideos() {
    var boxes = $all('.rl-mech-vid-inner[data-yt-loop]');
    if (!boxes.length) return;
    if (!('IntersectionObserver' in window)) { boxes.forEach(loadMechVid); return; }
    if (rlMechObs) rlMechObs.disconnect();
    rlMechObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { loadMechVid(en.target); rlMechObs.unobserve(en.target); }
      });
    }, { rootMargin: '200px 0px' });
    boxes.forEach(function (b) { if (!b.getAttribute('data-rl-loaded')) rlMechObs.observe(b); });
  }

  /* ---------- (re)init per section ---------- */
  function rlInitAll() {
    initSticky();
    initMechVideos();
    // ensure each product form reflects its checked variant on load
    $all('.rl-scope').forEach(function (scope) {
      var checked = scope.querySelector('.rl-variant input[type="radio"]:checked');
      if (checked) applyVariant(scope, checked);
    });
  }
  window.rlInitAll = rlInitAll;

  if (document.readyState !== 'loading') rlInitAll();
  else document.addEventListener('DOMContentLoaded', rlInitAll);

  // Theme Editor: re-run when a section is (re)rendered
  document.addEventListener('shopify:section:load', rlInitAll);
  document.addEventListener('shopify:section:unload', function () { if (rlObserver) rlObserver.disconnect(); if (rlMechObs) rlMechObs.disconnect(); });
})();
